import { render } from "./TotalSpendByChannel.vue?vue&type=template&id=02221c6c&scoped=true"
import script from "./TotalSpendByChannel.vue?vue&type=script&lang=js"
export * from "./TotalSpendByChannel.vue?vue&type=script&lang=js"

import "./TotalSpendByChannel.vue?vue&type=style&index=0&id=02221c6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02221c6c"]])

export default __exports__